import { useState } from "react";
import { faqList, trustStats } from "@/mocks/chigua";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-28 bg-ink text-cream">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        {/* 信任数据条 */}
        <div className="grid grid-cols-2 gap-5 sm:grid-cols-4">
          {trustStats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl bg-cream/5 px-5 py-6 text-center ring-1 ring-cream/10"
            >
              <p className="font-display-x text-3xl font-black text-amber">{s.num}</p>
              <p className="mt-1.5 text-xs text-cream/60">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr]">
          {/* 信任说明 */}
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-ember/20 px-3 py-1 text-xs font-bold text-peach">
              <i className="ri-shield-check-line" />
              说明与 FAQ · 更醒目
            </span>
            <h2 className="mt-4 font-display-x text-3xl font-black md:text-4xl">
              常见疑问，先说清楚
            </h2>
            <p className="mt-4 text-base leading-relaxed text-cream/70">
              素材类型多，难免会好奇「怎么归类」「能不能用」。我们把最常被问到的几点放在最前面，
              看完基本就能放心使用。
            </p>
            <ul className="mt-6 space-y-3">
              {[
                "片段 / 截图 / 录屏 / 回放类型划分清晰",
                "全部素材统一标注来源，可回溯求证",
                "表情包仅供传播使用，商用请核对版权",
              ].map((t) => (
                <li key={t} className="flex items-start gap-2.5 text-sm text-cream/80">
                  <i className="ri-checkbox-circle-line mt-0.5 text-amber" />
                  {t}
                </li>
              ))}
            </ul>
          </div>

          {/* 手风琴 FAQ */}
          <div className="space-y-3">
            {faqList.map((f, idx) => {
              const isOpen = openIdx === idx;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-2xl ring-1 transition ${
                    isOpen ? "bg-cream/10 ring-amber/40" : "bg-cream/5 ring-cream/10"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3 text-sm font-semibold text-cream md:text-base">
                      <i className="ri-question-line text-amber" />
                      {f.q}
                    </span>
                    <i
                      className={`ri-arrow-down-s-line text-xl text-cream/60 transition-transform ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-cream/70">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}